import {AsyncStorageSecurityContextHolder, SecurityContext} from './security-context.js';
import {ServerWebExchangeDecorator} from '../exchange.js';
import {ServerWebExchange} from '../../../types/web/server';
import {Principal} from '../../../types/auth';
import {AsyncLocalStorage} from "node:async_hooks";


export class SecurityContextServerWebExchange extends ServerWebExchangeDecorator {
    readonly #context: () => Promise<SecurityContext | undefined>;
    constructor(exchange: ServerWebExchange, context: () => Promise<SecurityContext | undefined>) {
        super(exchange);
        this.#context = context;
    }

    async principal<T extends Principal>(): Promise<T | undefined> {
        const context = await this.#context();
        return context?.authentication as (T | undefined);
    }
}

export const exchangeFilter = (opts: {storage: AsyncLocalStorage<{ securityContext?: Promise<SecurityContext> }>}) => {
    const storage = opts.storage;
    return async (exchange: ServerWebExchange, next: (exchange: ServerWebExchange) => Promise<void>) => {
        await next(new SecurityContextServerWebExchange(exchange, async () => await AsyncStorageSecurityContextHolder.getContext(storage)));
    }
}
